import { apiFetch } from "./apiClient";

export const fetchProfile = async () => apiFetch("/api/profile");

export const updateProfile = async (updates) =>
  apiFetch("/api/profile", { method: "PUT", body: updates });
